import { createFileRoute } from "@tanstack/react-router"

import { DirectoryPanel } from "@/pages/DirectoryPanel"

export const Route = createFileRoute("/administration/directory")({
  component: DirectoryPanel,
})
